//return false as we don't support any rooms for now
//we are however keeping the functionality because we will soon have other experiments using it
export const isTaskBreakdownSupported = (_: string) => false;
